import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';
import Cookies from 'js-cookie';

const PasswordCheck = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Hardcoded hash for the password
  const hardcodedHash = '$2a$12$y09QQpRIdx5k1bEMzwNCJu1Lb0boYMMUrlIOvymdL6pCSYY.lGChe'; // Example hash

  useEffect(() => {
    // Check if the session cookie exists
    const sessionCookie = Cookies.get('session');
    if (sessionCookie) {
      navigate('/home'); // Redirect to Home.js if session exists
    }
  }, [navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Compare the entered password with the hardcoded hash
    if (bcrypt.compareSync(password, hardcodedHash)) {
      // Set a session cookie
      Cookies.set('session', 'active', { expires: 1 / 24 / 60 }); // Expires in 1 minute
      navigate('/home'); // Redirect to Home.js
    } else {
      setError('Incorrect password. Please try again.');
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h3>Beta Access Check</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your access code"
          required
        />
        <button type="submit">Submit</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

export default PasswordCheck;
